export function createOutboxEntry(entityType, entityId, budgetId, operationType, payload, baseVersion) {
    return {
        opId: crypto.randomUUID(),
        entityType,
        entityId,
        budgetId,
        operationType,
        baseVersion,
        payload,
        clientTimestampUtc: new Date().toISOString(),
        status: 'pending',
        retryCount: 0,
        createdAt: new Date().toISOString(),
    };
}
